import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/activity/time-entry/query/', 'Activities');

tbl.add(new Xtc('creator', 'User').renderSlot('user'))
tbl.add(new Xtc('matter.title', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('duration', 'Duration').renderSlot('duration'))
tbl.add(new Xtc('rate', 'Rate(s)').renderSlot('rate'))
tbl.add(new Xtc('date', 'Date').renderSlot('date'))
tbl.add(new Xtc('billable', 'Non billable').renderSlot('NonBillable').noSort())
tbl.add(new Xtc('non_billable', 'Billable').renderSlot('billable').noSort())
tbl.add(new Xtc('is_used_in_invoice', 'Used invoice').renderSlot('invoice').noSort())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

